import * as api from "./api";

export const getUser = (params) => {
  return api.get("/user", params);
};

export const updateUser = (params) => {
  return api.put("/user", params);
};

export const removeUser = (params) => {
  return api.remove("/user", params);
};
